// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1Cl__","emails":"CreateEditClinics_emails__IQ0ti","emailTagLabel":"CreateEditClinics_emailTagLabel__3gpEI"};